import React from "react";
import { Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import "./contactUs.styles.css";

const ContactUs = (props) => {
  return (
    <section className="contact">
      <h1 className="contactSubHeader">Contact Us</h1>
      <Form className="contact-us">
        <div className="contactWrapper">
          <Form.Group className="mb-3 form-group">
            <Form.Label className="contactSubText">Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your name"
              className="customInput"
            />
          </Form.Group>
          <Form.Group className="mb-3 form-group">
            <Form.Label className="contactSubText">Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              className="customInput"
            />
          </Form.Group>
          <Form.Group className="mb-3 form-group">
            <Form.Label className="contactSubText">Message</Form.Label>
            <Form.Control as="textarea" rows="3" className="customInput" placeholder="Enter Your Message" />
          </Form.Group>
          <Form.Group className="mb-3 form-group submit">
            <Button variant="primary" type="submit">
            Submit
          </Button>
          </Form.Group>
        </div>
      </Form>
    </section>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
